import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormMetricsChartType } from 'services/models/form-builder/form-metrics/form-metrics.enum';
import { FormMetricsCategoryClickEvent } from 'services/models/form-builder/form-metrics/form-metrics-drilldown.model';
import { FormMetricsRespondentAnswerItemModel } from 'services/models/form-builder/form-metrics/form-metrics-drilldown.model';
import { FormMetricsDashboardModel } from 'services/models/form-builder/form-metrics/form-metrics-dashboard.model';
import { FormMetricsFilter } from 'services/models/form-builder/form-metrics/form-metrics-filter.model';
import { FormMetricsGroupModel } from 'services/models/form-builder/form-metrics/form-metrics-group.model';
import { FormMetricsItemModel } from 'services/models/form-builder/form-metrics/form-metrics-item.model';
import {
  FormMetricsCommentsFetcher,
  FormMetricsCommentsModalComponent,
} from '../form-metrics-comments-modal/form-metrics-comments-modal.component';
import { commentsFromHighlightAnswers } from '../utils/form-metrics-drilldown.util';

@Component({
  selector: 'app-form-metrics-dashboard',
  templateUrl: './form-metrics-dashboard.component.html',
  styleUrls: ['./form-metrics-dashboard.component.scss'],
})
export class FormMetricsDashboardComponent implements OnChanges {
  @Input() dashboard: FormMetricsDashboardModel | null = null;
  @Input() formId: string;
  @Input() filters: FormMetricsFilter = {};
  @Input() highlightedEmployeeId: string | null = null;
  @Input() loading = false;
  @Input() highlightLoading = false;
  @Input() showHeader = true;
  @Input() categoryClickEnabled = false;
  @Input() highlightAnswers: FormMetricsRespondentAnswerItemModel[] = [];
  @Input() commentsFetcher: FormMetricsCommentsFetcher | null = null;
  @Output() categoryClick = new EventEmitter<FormMetricsCategoryClickEvent>();

  sortedGroups: FormMetricsGroupModel[] = [];
  hasVisibleItems = false;
  allItemsEmpty = false;

  constructor(private modalService: NgbModal) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dashboard']) {
      this.refreshViewState();
    }
  }

  openComments(item: FormMetricsItemModel): void {
    const modalRef = this.modalService.open(FormMetricsCommentsModalComponent, {
      centered: false,
      backdrop: false,
      animation: false,
      windowClass: 'form-metrics-drawer-modal',
    });

    modalRef.componentInstance.formId = this.formId || this.dashboard?.formId;
    modalRef.componentInstance.formItemId = item.formItemId;
    modalRef.componentInstance.title = item.label || 'Comentários';
    modalRef.componentInstance.filters = this.filters || {};
    modalRef.componentInstance.highlightedEmployeeId = this.highlightedEmployeeId;
    modalRef.componentInstance.highlightedComments = commentsFromHighlightAnswers(
      this.highlightAnswers,
      item.formItemId
    );
    modalRef.componentInstance.commentsFetcher = this.commentsFetcher || null;
  }

  onCategoryClick(event: FormMetricsCategoryClickEvent): void {
    this.categoryClick.emit(event);
  }

  trackByGroupId(_: number, group: FormMetricsGroupModel): string {
    return group.groupId;
  }

  private refreshViewState(): void {
    const groups = this.dashboard?.groups || [];
    this.sortedGroups = [...groups].sort((a, b) => (a.order || 0) - (b.order || 0));

    const visibleItems = this.sortedGroups
      .reduce((acc, group) => acc.concat(group.items || []), [] as FormMetricsItemModel[])
      .filter(item => item.chartType !== FormMetricsChartType.UNSET);

    this.hasVisibleItems = visibleItems.length > 0;
    this.allItemsEmpty = this.hasVisibleItems && visibleItems.every(item => item.totalAnswers === 0);
  }
}
